<script lang="ts" setup>
// Packages
import { faCalendar } from '@fortawesome/free-regular-svg-icons';

// ---------------------------------------
// Composables
// ---------------------------------------

const dayjs = useDayjs();

const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  date: { type: String, required: true },
  location: { type: String, required: true },
  image: { type: String, required: false },
  startAt: { type: String, required: true },
  showImg: { type: Boolean, required: false, default: false },
});

// ---------------------------------------
// State
// ---------------------------------------

</script>
<template>
  <li class="card flex">
    <!-- Time -->
    <time datetime="" class="py-4 pr-4 md:p-6 flex flex-col justify-start">
      <span class="text-center">{{ $dayjs(startAt).format('ddd') }}</span>
      <span class="text-3xl my-2 text-center font-bold">{{ $dayjs(startAt).format('DD') }}</span>
    </time>

    <div class="flex flex-wrap lg:flex-nowrap flex-1">
      <!-- Content -->
      <div class="py-6 lg:px-6 block mb-8 order-2 flex-1">
        <!-- Full date -->
        <time datetime="" class="flex items-center text-gray-500 mb-2">
          <font-awesome :icon="faCalendar"/>
          <span class="mx-2">
            {{ $dayjs(startAt).format('LL') }}
          </span>
        </time>
        <span class="text-3xl mb-4 block font-bold hover:underline cursor-pointer">
          {{ title }}
        </span>
        <!-- Address -->
        <span class="mb-4 block">
          {{ location }}
        </span>
        <span class="block mb-2 font-light whitespace-break-spaces">{{ description }}</span>
      </div>
  
      <div class="image-container order-1 lg:order-2 w-full overflow-hidden" v-if="!showImg">
        <img
          v-if="image"
          class="hover:scale-110 transition-all duration-500 cursor-pointer"
          :src="image"
          alt=""
          onerror="this.onerror=null;this.src='https://assets.terreirovoritadasalmas.com.br/illustrations/default-cover-blank.svg'"
        >
      </div>
    </div>

  </li>
</template>
<style lang="scss" scoped>
.card {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.image-container {
  position: relative;
  max-width: 416px;
  max-height: 274px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.media {
  position: relative;
}

@media screen and (max-width:1022px) {
  .image-container {
    position: relative;
    max-width: unset;
    max-height: 473px;
    overflow: hidden;
  }
}
</style>